import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Breadcrumb from "../../components/Breadcrumb";
import CourseGridAdult from "./CourseGridAdult";
import ScrollToTop from "../../components/ScrollTop";
import DownloadApp from "../home/DownloadApp";

const Course = () => {
  return (
    <body className="courses-grid-page">
      <Header parentMenu="course" menuCategoryEnable="enable" />

      <div className="react-wrapper">
        <div className="react-wrapper-inner">
          <Breadcrumb pageTitle="Adult French Courses" />
          <CourseGridAdult />
          {/* download-app-start */}
          <DownloadApp />
          {/* download-app-end */}
          {/* scrolltop-start */}
          <ScrollToTop />
          {/* scrolltop-end */}
        </div>
      </div>

      <Footer />
    </body>
  );
};

export default Course;
